import zsmLayout from '@/zsm-layout'

const shopRouter = {
  path: '/shop',
  component: zsmLayout,
  name: 'shop',
  children: [
    {
      path: '/shop',
      component: () => import('@/view/shop/index'),
      name: 'shop',
      meta: {
        title: '店铺管理', icon: 'antFill-home', affix: true,
        childList: [
          { meta: { title: '知识店铺基本资料' }, title: '知识店铺基本资料', path: '/shop/knowledge' },
          { meta: { title: '服务店铺基本资料' }, title: '服务店铺基本资料', path: '/shop/part-time' }
        ]
      },
      redirect: '/shop/knowledge',
      children: [
        {
          path: '/shop/knowledge',
          component: () => import('@/view/shop/knowledge'),
          name: 'knowledge',
          hidden: true
        },
        {
          path: '/shop/part-time',
          component: () => import('@/view/shop/part-time'),
          name: 'knowledge',
          hidden: true
        }
      ]
    }
  ]
}

export default shopRouter
